import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RmField from "./RmField";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './react-datepicker.css';

export default class RmDateTimeField extends Component {
    handleChange(dateVal) {
        let m = moment(dateVal);

        if (m.isValid()) {
            this.props.onChange(m.format('YYYY-MM-DDTHH:mm:ssZ'));
        } else {
            this.props.onChange(null);
        }
    }

    render() {
        let {...props} = this.props;

        let selectedValue = null;

        if (this.props.value) {
            let parsedMoment = moment(this.props.value);

            if (parsedMoment.isValid()) {
                selectedValue = parsedMoment;
            }
        }

        let style = { };

        if (this.props.zIndex) {
            style.zIndex = this.props.zIndex;
        }

        let io = <div className={"RmDateTimeField"} style={style}>
            <DatePicker
                selected={selectedValue}
                onChange={this.handleChange.bind(this)}
                placeholderText={this.props.label}
                dateFormat={RmDateTimeField.DATE_FORMAT}
                disabled={this.props.disabled}
            />
        </div>;

        return (
            <RmField {...props}
                     inputType={"textarea"} inputOverride={io}/>
        );
    }
}

RmDateTimeField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    marginOff: PropTypes.bool,
    className: PropTypes.string,
    rows: PropTypes.number,
    zIndex: PropTypes.number
};

RmDateTimeField.DATE_FORMAT = "DD-MM-YYYY";



// WEBPACK FOOTER //
// ./src/Forms/RmDateTimeField.js